import React from "react"
import {
  Formik,
  Form as FormikForm,
  Field,
  //useFormikContext
} from "formik"
import * as Yup from "yup"
import * as Constants from "../../../common/constants"
import FormTextbox from "../WindscreenClaim/components/formTextbox"
import FormFieldDisableAutoComplete from "../WindscreenClaim/components/formFieldDisableAutoComplete"
import FormMobileTextBox from "../WindscreenClaim/components/formMobileTextBox"
import FormDropdownArray from "../WindscreenClaim/components/formDropdownArray"
import FormDatePickerTextBox from "../WindscreenClaim/components/formDatePickerTextBox"
import format from "date-fns/format"
import { Row, Col } from "react-bootstrap"
// import parse from 'date-fns/parse'
// import isValid from 'date-fns/isValid'
// import { isBefore, parse, format, isValid } from "date-fns"

const PolicyInformation = React.memo(({ claimData, uiData }) => {
  const { pageNumber, clickedNext, workshopList, isMasterAccClaim } = uiData
  const todayDate = format(new Date(), `d${Constants.sep}M${Constants.sep}yyyy`)

  const category = "claimInfo"
  const details = "policyInfo"
  const formName = "Policy Information"

  const formClickedNext = clickedNext[formName]

  const policyInfoSchema = Yup.object().shape({
    workshop: Yup.string().required(Constants.workshopErrorMsg),
    otherWorkshopName: Yup.string().when("workshop", {
      is: value => value === "Others",
      then: Yup.string().required(Constants.workshopNameErrorMsg),
    }),
    otherWorkshopContactNo: Yup.string().when("workshop", {
      is: value => value === "Others",
      then: Yup.string().required(Constants.workshopContactNoErrorMsg),
    }),
    otherWorkshopAddress: Yup.string().when("workshop", {
      is: value => value === "Others",
      then: Yup.string().required(Constants.workshopAddressErrorMsg),
    }),
    workshopContactPerson: Yup.string()
      .required(Constants.workshopContactPersonErrorMsg)
      .matches(Constants.namepattern, Constants.workshopContactPersonErrorMsg),
    workshopEmail: Yup.string()
      .required(Constants.workshopEmailErrorMsg)
      .email(Constants.workshopEmailErrorMsg),

    policyNumber: Yup.string()
      .length(8, Constants.policyNumberErrorMsg)
      .required(Constants.policyNumberErrorMsg)
      .matches(Constants.policyPattern, Constants.policyNumberErrorMsg),

    // Below for Gigantiq validation
    // .test({
    //   name: "validator-entered-master-account-regex",
    //   test: function(value) {
    //     const masterAccountPatternRegex = RegExp(
    //       Constants.masterAccountPattern
    //     )
    //     const policyPatternRegex = RegExp(Constants.policyPattern)
    //     let passValidation = false

    //     //Validate user entered data is policy number or master account
    //     if (masterAccountPatternRegex.test(value)) {
    //       passValidation = true
    //     }
    //     if (policyPatternRegex.test(value)) {
    //       passValidation = true
    //     }

    //     if (passValidation) {
    //       return true //Pass validation
    //     } else {
    //       // Creare error message
    //       this.createError({
    //         message: Constants.policyNumberErrorMsg,
    //         path: "policyNumber", // Fieldname
    //       })
    //     }
    //   },
    // }),
    vehicleNumber: Yup.string().required(Constants.vehicleNumberErrorMsg),
    //.matches(Constants.namepattern, Constants.vehicleNumberErrorMsgErrorMsg),

    policyHolderName: Yup.string()
      .required(Constants.policyHolderNameErrorMsg)
      .matches(Constants.namepattern, Constants.policyHolderNameErrorMsg),
    // claimantNricNumber: Yup.string()
    //   .required(Constants.claimantNricErrorMsg),
    // .matches(Constants.nricpattern, Constants.claimantNricErrorMsg),
    claimantEmail: Yup.string()
      //.required(Constants.claimantEmailErrorMsg)
      .email(Constants.claimantEmailErrorMsg),
    claimantMobile: Yup.string()
      //.required(Constants.claimantMobileErrorMsg)
      // .length(8, Constants.mobileErrorMsg)
      .matches(Constants.mobilepattern, Constants.claimantMobileErrorMsg),

    accidentDate: Yup.string()
      .trim()
      .required(Constants.accidentDateErrorMsg),
  })

  return (
    <Formik
      initialValues={claimData[category][details]}
      enableReinitialize={true}
      validationSchema={policyInfoSchema}
      validateOnMount={true}
    >
      {({ handleSubmit, isValid, values }) => (
        <FormikForm onSubmit={handleSubmit}>
          <Row className={pageNumber === 1 ? "" : "hide"}>
            <div className="title text-center MarginTop75">
              Submit online windscreen claim
            </div>
            <Row className={"containerBody marginTop3x"}>
              <Col
                xs={{ span: 12, offset: 0 }}
                md={{ span: 12, offset: 0 }}
                className="formContainer"
              >
                <div className="horizontal-align marginBottom1x">
                  <Col xs={12} md={12}>
                    <div
                      className={
                        "titleText " + (pageNumber !== 1 ? "hide" : "")
                      }
                    >
                      Workshop Information
                    </div>
                  </Col>
                </div>
                <div>
                  {/* Fake fields are a workaround for chrome autofill getting the wrong fields */}
                  <Field
                    textDesc={"Disable Auto Complete"}
                    name="disableAutoComplete"
                    component={FormFieldDisableAutoComplete}
                  />
                  <Field
                    textDesc={"Workshop"}
                    coverageCategory={category}
                    coverageCode={details}
                    name="workshop"
                    component={FormDropdownArray}
                    propertyName={"Workshop"}
                    dropdownItem={workshopList}
                    formIsValid={isValid}
                    formName={formName}
                    clickedNext={formClickedNext}
                    extraFieldValue={["Others"]}
                    affectedField={[
                      "otherWorkshopName",
                      "otherWorkshopContactNo",
                      "otherWorkshopAddress",
                    ]}
                    secondPropertyName={"ID"}
                    secondFieldName={"workshopId"}
                  />
                  {values.workshop && values.workshop === "Others" && (
                    <>
                      {/* Fake fields are a workaround for chrome autofill getting the wrong fields */}
                      <Field
                        textDesc={"Disable Auto Complete"}
                        name="disableAutoComplete"
                        component={FormFieldDisableAutoComplete}
                      />
                      <Field
                        textDesc={"Name of Workshop"}
                        coverageCategory={category}
                        coverageCode={details}
                        maxLength={200}
                        name="otherWorkshopName"
                        component={FormTextbox}
                        formIsValid={isValid}
                        formName={formName}
                        clickedNext={formClickedNext}
                        toUpperCase={false}
                      />
                      <Field
                        textDesc={"Contact Number"}
                        coverageCategory={category}
                        coverageCode={details}
                        maxLength={9}
                        name="otherWorkshopContactNo"
                        component={FormMobileTextBox}
                        formIsValid={isValid}
                        formName={formName}
                        clickedNext={formClickedNext}
                      />
                      <Field
                        textDesc={"Address of Workshop"}
                        coverageCategory={category}
                        coverageCode={details}
                        maxLength={200}
                        name="otherWorkshopAddress"
                        component={FormTextbox}
                        formIsValid={isValid}
                        formName={formName}
                        clickedNext={formClickedNext}
                        toUpperCase={false}
                      />
                    </>
                  )}

                  <Field
                    textDesc={"Contact Person"}
                    coverageCategory={category}
                    coverageCode={details}
                    maxLength={50}
                    name="workshopContactPerson"
                    component={FormTextbox}
                    formIsValid={isValid}
                    formName={formName}
                    clickedNext={formClickedNext}
                    toUpperCase={true}
                  />
                  <Field
                    textDesc={"Workshop Email"}
                    coverageCategory={category}
                    coverageCode={details}
                    maxLength={100}
                    name="workshopEmail"
                    component={FormTextbox}
                    formIsValid={isValid}
                    formName={formName}
                    clickedNext={formClickedNext}
                    toUpperCase={false}
                  />
                </div>
              </Col>
            </Row>
            <Row className={"containerBody marginTop3x "}>
              <Col
                xs={{ span: 12, offset: 0 }}
                md={{ span: 12, offset: 0 }}
                className="formContainer"
              >
                <div className="horizontal-align marginBottom1x">
                  <Col xs={12} md={12}>
                    <div
                      className={
                        "titleText " + (pageNumber !== 1 ? "hide" : "")
                      }
                    >
                      Policy Information
                    </div>
                  </Col>
                </div>
                <Field
                  textDesc={"Policy Number"}
                  coverageCategory={category}
                  coverageCode={details}
                  maxLength={20}
                  name="policyNumber"
                  component={FormTextbox}
                  formIsValid={isValid}
                  formName={formName}
                  clickedNext={formClickedNext}
                  toUpperCase={true}
                />
                <Field
                  textDesc={"Vehicle Number"}
                  coverageCategory={category}
                  coverageCode={details}
                  maxLength={20}
                  name="vehicleNumber"
                  component={FormTextbox}
                  formIsValid={isValid}
                  formName={formName}
                  clickedNext={formClickedNext}
                  toUpperCase={true}
                />
                <Field
                  textDesc="Accident Date"
                  coverageCategory={category}
                  coverageCode={details}
                  name="accidentDate"
                  component={FormDatePickerTextBox}
                  formIsValid={isValid}
                  formName={formName}
                  clickedNext={formClickedNext}
                  disableAfter={todayDate}
                />
              </Col>
            </Row>
            <Row className={"containerBody marginTop3x"}>
              <Col
                xs={{ span: 12, offset: 0 }}
                md={{ span: 12, offset: 0 }}
                className="formContainer"
              >
                <div className="horizontal-align marginBottom1x">
                  <Col xs={12} md={12}>
                    <div
                      className={
                        "titleText " + (pageNumber !== 1 ? "hide" : "")
                      }
                    >
                      Details Of Policy
                    </div>
                  </Col>
                </div>
                {/* Fake fields are a workaround for chrome autofill getting the wrong fields */}
                <Field
                  textDesc={"Disable Auto Complete"}
                  name="disableAutoComplete2"
                  component={FormFieldDisableAutoComplete}
                />
                <Field
                  textDesc={"Name of Insured as per policy schedule"}
                  coverageCategory={category}
                  coverageCode={details}
                  maxLength={100}
                  name="policyHolderName"
                  component={FormTextbox}
                  formIsValid={isValid}
                  formName={formName}
                  clickedNext={formClickedNext}
                  toUpperCase={true}
                />
                <Field
                  textDesc={"Policyholder's NRIC/PP No"}
                  coverageCategory={category}
                  coverageCode={details}
                  maxLength={10}
                  name="claimantNricNumber"
                  component={FormTextbox}
                  formIsValid={isValid}
                  formName={formName}
                  clickedNext={formClickedNext}
                  toUpperCase={true}
                />
                <Field
                  textDesc={"Policyholder's Email"}
                  coverageCategory={category}
                  coverageCode={details}
                  maxLength={100}
                  name="claimantEmail"
                  component={FormTextbox}
                  formIsValid={isValid}
                  formName={formName}
                  clickedNext={formClickedNext}
                  toUpperCase={false}
                />
                <Field
                  textDesc={"Policyholder's Mobile Number"}
                  coverageCategory={category}
                  coverageCode={details}
                  maxLength={9}
                  name="claimantMobile"
                  component={FormMobileTextBox}
                  formIsValid={isValid}
                  formName={formName}
                  clickedNext={formClickedNext}
                />
              </Col>
            </Row>
          </Row>
          {/* <AutoSubmit clickedNext={clickedNext[details]} /> */}
        </FormikForm>
      )}
    </Formik>
  )
})
export default PolicyInformation
